// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__fQpf4","disabled":"Avatar_disabled__39OQu","image":"Avatar_image__1QE6t","image-disabled":"Avatar_image-disabled__37UCX","icon":"Avatar_icon__3jcnj"};